import { Component, ComponentRef, inject, Input, input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordMatchValidator } from '../../../shared/utils/mustMatchValidators';
import { DialogRef } from '@angular/cdk/dialog';
import { ProfileService } from '../../../domain/service/profileService';
import { ChangePassword } from '../../../domain/model/profile/changePassword';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { NotificationType } from '../../../domain/model/enums/notificationType';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationComponent } from '../../../shared/notification/notification.component';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { HttpResponseDto } from '../../../domain/model/common/httpResponseDto';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})

export class ChangePasswordComponent implements OnInit {
  
   constructor(private profileService: ProfileService,private readonly auth: AuthenticationService){
    this.externalUser = this.auth.getCurrentUser2();
    
   }  
   private overlay!: Overlay;
  ngOnInit(): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().top("20px").right("30px"),
    });
  }
 
 private overlayRef!: OverlayRef;
     externalUser!: ExternalUser | null;
  hide = true;
  hideC = true;
  hideCurrent = true;
  dialogRef = inject<DialogRef<HttpResponseDto>>(DialogRef<string>);
  changePassword = new FormGroup({
    currentPassword: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
    ]),
    password: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
    ]),
    confirmPassword: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
      
    ]),
  } ,{validators: passwordMatchValidator('password', 'confirmPassword')});
 
strongPassword = false;
onPasswordStrengthChanged(event: boolean) {
  this.strongPassword = event;
}
get passwordMismatch() {
  let confirmPassword =  this.changePassword.get('confirmPassword')?.value ?? '';
  return this.changePassword.hasError('passwordMismatch') && (confirmPassword.length > 0);
}
  
save() { 
  let model : ChangePassword = {
    userId: this.externalUser?.userId??0,
    password: this.changePassword.get("password")?.value ?? "",
    newPassword: this.changePassword.get("confirmPassword")?.value ?? "",
  };
  this.profileService.changePassword(model).subscribe({
    next: (response) => {  
      this.dialogRef.close(response);
    
     
      console.log(response)
    },
    error: (error) => {
      this.dialogRef.close();
      // this.showNotification(
      //   "Current password is invalid .",
      //   "Change Password",
      //   NotificationType.Error
      // );
    },
    complete: () => {},
  });
}
}
